import React, { useState } from 'react';
import { Typography } from '@mui/material';

import { Link } from 'theSource/components';
import { CardContentProps } from './types';
import { ModalStyled } from './PageContentCardStyled';

export const FullPageCardContent = ({
  label,
  content,
  documents,
  url,
  urlType,
}: CardContentProps) => {
  const [modalState, setModalState] = useState<boolean>(false);
  return (
    <React.Fragment>
      <Typography gutterBottom variant="body1Heading" component="h2">
        {label}
      </Typography>
      {content && (
        <Typography
          variant="body1"
          component="div"
          dangerouslySetInnerHTML={{ __html: content }}
          data-testid="full-page-content"
        />
      )}
      {documents && documents?.length > 0 && (
        <Typography>
          <ul>
            {documents.map((document: any, index: number) => (
              <li key={index}>
                <Link
                  path={`${document.document_url}`}
                  value={document.label || 'document'}
                  target="_blank"
                  download
                />
              </li>
            ))}
          </ul>
        </Typography>
      )}
      {url && urlType === 'new_window' && (
        <Link path={url} target="_blank" value={label || ''} />
      )}
      {url && urlType !== 'new_window' && (
        <>
          <button onClick={() => setModalState(true)}>video pop up</button>
          <ModalStyled open={modalState} onClose={() => setModalState(false)}>
            <div className="modal-content-wrapper modal-dialog">
              <div className="modal-header align-items-center">
                <h2 className="modal-title">Header</h2>
              </div>
              <div className="modal-body text-center">
                <iframe
                  src={url}
                  sandbox="allow-scripts allow-same-origin allow-presentation"
                  allow="autoplay; fullscreen"
                  title="Content Video"
                  onLoad={(e) => {
                    e.currentTarget.classList.add('show-video');
                  }}
                  allowFullScreen
                />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-link"
                  onClick={() => setModalState(false)}
                >
                  Close{' '}
                </button>
              </div>
            </div>
          </ModalStyled>
        </>
      )}
    </React.Fragment>
  );
};
